export function createLegendListController() {
    return {
        useProps(props) {
            const handleClick = (item) => {
                const nextValue = props.visible.value.includes(item.key)
                    ? props.visible.value.filter((candidate) => candidate !== item.key)
                    : [...props.visible.value, item.key];
                props.visible.onChange(nextValue);
            };
            return {
                items: props.datasets.map((item) => ({
                    label: item.name ?? item.key,
                    description: item.description,
                    toggle: {
                        onClick: handleClick.bind(null, item),
                    },
                    color: item.color,
                    checkbox: {
                        isChecked: props.visible.value.includes(item.key),
                    },
                })),
            };
        },
    };
}
//# sourceMappingURL=legendListController.js.map